import React, { useEffect, useState } from "react";
import axios from 'axios';
import {Link} from 'react-router-dom';

const Wallet = () => {
    const [bal, setBal] = useState(0);
    const [loan,setLoan] = useState(0);

    useEffect(() => {

        
        const fetchData = async () => {
            var userid= localStorage.getItem('userid');
            axios.get('https://octafxx.in/Rest/home_wallet_api/'+userid).then(res => {
                console.log(res.data);
                setBal(res.data.bal);
                setLoan(res.data.loan_amt);
            });
        };

        fetchData();
    }, []);

    return (
        <div className="section pt-1">
            <div className="wallet-card">
                <div className="balance">
                    <div className="left">
                        <span className="title text-light">Total Balance</span>
                        <h1 className="total text-light">${bal}</h1>
                    </div>
                    <div className="right">
                        <span className="title text-light">Loan Credit</span>
                        <h1 className="total text-light">${loan}</h1>
                    </div>
                </div>
                
                <div className="wallet-footer">
                        <div className="left mt-1">
                            <Link to="/deposite" className='btn btn-primary'>DEPOSIT</Link>
                        </div>
                        <div className="right mt-1">
                            <Link to="/withdrawl" className='btn btn-warning'>WITHDRAW</Link>
                        </div>
                </div>
            </div>
        </div>
    );
};

export default Wallet;